export enum Product {
  SPT,
  FWD,
  NDF,
  SWP,
  SSP,
}

export namespace Product {
  let elements = [Product.SPT, Product.FWD, Product.NDF, Product.SWP, Product.SSP];
  let alias = "com.bcdfx.model.Product";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
